import { Input, InputProps } from '@chakra-ui/react';
import React, { forwardRef } from 'react';

    /* eslint-disable-next-line */
const CustomInput = forwardRef<HTMLInputElement, InputProps>((props, ref) => {
  return (
    <Input
      variant="outline"
      backgroundColor={'#fff'}
      maxLength={100}
      borderColor="gray.300"
      _hover={{
        borderColor: 'blue.500',
      }}
      _focus={{
        borderColor: 'blue.500',
        boxShadow: '0 0 0 1px blue.500',
      }}
      {...props}
      ref={ref}
    />
  );
});

export default CustomInput;
